<template>
  <layout-main-inner title="风险预警">
    <layout-card-wrap hasHeaderSlot
                      v-loading="loading">
      <template slot="title">
        <el-button type="primary"
                   icon="el-icon-plus"
                   @click="create">新建风险预警</el-button>
      </template>
      <template slot="form">
        <assign-ent-select immediate
                           v-model="config.vendorId"
                           style="margin-right: 10px"
                           :option="{}"
                           :callback="() => { handleCurrentChange(1) }" />
        <!-- <ent-product-auto-select v-model="config.productId"
                                 :callback="() => { handleCurrentChange(1) }" /> -->
        <el-button type="primary"
                   style="margin-left: 10px"
                   @click=" handleCurrentChange(1) ">查询</el-button>
      </template>
      <el-table border
                :data="list">
        <el-table-column label="商品名称"
                         min-width="200"
                         fixed="left"
                         prop="productName"></el-table-column>
        <el-table-column label="企业名称"
                         min-width="240"
                         prop="vendorName"></el-table-column>
        <el-table-column label="批次信息"
                         min-width="80">
          <template slot-scope="{row}"> {{ row.status === 1 ? '生效中' : '已失效'}} </template>
        </el-table-column>
        <el-table-column label="预警信息"
                         min-width="360"
                         prop="warning"></el-table-column>
        <el-table-column label="状态"
                         min-width="80">
          <template slot-scope="{row}">
            <span :style="{ color: row.status === 0 ? 'red' : null }">{{ row.status === 1 ? '生效中' : '已失效'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="应用批次"
                         min-width="80">
          <template slot-scope="{ row }">
            <el-link type="primary"
                     v-if="row.batchs"
                     style="font-size: 12px;"
                     @click="viewBatch(row)"
                     :underline="false">{{ row.batchs.length }} 个</el-link>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         fixed="right"
                         width="100">
          <template slot-scope="{row}">
            <el-button type="text"
                       @click="deleteItem(row)">删除</el-button>
            <el-button type="text"
                       :disabled="row.status === 0"
                       @click="closeItem(row)">关闭</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <el-pagination background
                       @current-change="handleCurrentChange"
                       :current-page="config.pageNum"
                       :page-size="config.pageSize"
                       layout="total,  prev, pager, next"
                       :total="total">
        </el-pagination>
      </template>
    </layout-card-wrap>

    <risk-warning-modal ref="modal"
                        :callback="fetchList" />
    <batch-modal ref="batch" />
  </layout-main-inner>
</template>
<script>
import AssignEntSelect from '@/components/business/assign-ent-select.vue'
// import EntProductAutoSelect from '@/components/business/ent-product-auto-select.vue'
import RiskWarningModal from './risk-warning/risk-warning-modal.vue'
import BatchModal from './risk-warning/batch-modal.vue'
export default {
  name: 'risk-warning-list',
  components: { AssignEntSelect, RiskWarningModal, BatchModal },
  data () {
    return {
      loading: false,
      config: { pageNum: 1, pageSize: 10, productId: null, vendorId: null },
      list: [],
      total: 0
    }
  },
  methods: {
    viewBatch (row) {
      const { productName, vendorName, batchs } = row
      this.$refs.batch.fetch({ productName, vendorName }, batchs)
    },
    create () {
      this.$refs.modal.init()
    },
    deleteItem (row) {
      this.$confirm('是否删除该风险预警', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$$SuperviseApi.deleteriskwarning({ id: row.id })
            .then(res => {
              const { result, message } = res.data
              this.loading = false
              if ([0].includes(result)) {
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    closeItem (row) {
      this.$confirm('是否关闭该风险预警', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$$SuperviseApi.enableriskwarning({ id: row.id, enable: false })
            .then(res => {
              const { result, message } = res.data
              this.loading = false
              if ([0].includes(result)) {
                this.$message.success('关闭成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    handleCurrentChange (current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList () {
      this.loading = true
      this.$$SuperviseApi.getriskwarnings(this.config)
        .then(res => {
          const { result, message, total, records } = res.data
          this.loading = false
          if ([0, 13].includes(result)) {
            this.total = total
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>
